import { LocationMatchesRoomsState, LocationMatchesRoomsActionTypes, LOCATION_MATCHES_ROOMS_REQUEST, LOCATION_MATCHES_ROOMS_SUCCESS, LOCATION_MATCHES_ROOMS_FAILURE } from "store/reducers/room/locationMatchesRooms/types";

const defaultState: LocationMatchesRoomsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLocationMatchesRoomsData(state = defaultState, action: LocationMatchesRoomsActionTypes): LocationMatchesRoomsState {
  switch (action.type) {
    case LOCATION_MATCHES_ROOMS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LOCATION_MATCHES_ROOMS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LOCATION_MATCHES_ROOMS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};